import { render } from "./Login.vue?vue&type=template&id=dbc8c572&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=dbc8c572&scoped=true&lang=css"
import "./Login.vue?vue&type=style&index=1&id=dbc8c572&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbc8c572"]])

export default __exports__